export const projectsConstants = {
    errors: {
        fetchFailed: "Failed to load projects.",
        detailFetchFailed: "Failed to load project.",
        createFailed: "Failed to create project.",
        updateFailed: "Failed to update project.",
        deleteFailed: "Failed to delete project.",
        sprintsFetchFailed: "Failed to load project sprints.",
    },
    messages: {
        createSuccess: "Project created.",
        updateSuccess: "Project updated.",
        deleteSuccess: "Project deleted.",
    },
};
